import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ContextService } from '@perval/shared';
import { Nullable } from '../../../shared/types';
import { Utilisateur } from '../../models/utilisateur';
import { UtilisateurService } from '../../services/utilisateur.service';

@Component({
  templateUrl: './collaborater-profile.component.html',
  styleUrls: ['./collaborater-profile.component.scss'],
})
export class CollaboraterProfileComponent implements OnInit {
  private _collabUser!: Partial<Nullable<Utilisateur>>;
  private _canEdit!: Utilisateur.CanEdit;

  get collabUser(): Partial<Nullable<Utilisateur>> {
    return this._collabUser;
  }

  get canEdit(): Utilisateur.CanEdit {
    return this._canEdit;
  }

  get isCurrentUserNotaire(): boolean {
    return this.contextService.isNotaire;
  }

  constructor(
    private readonly utilisateurService: UtilisateurService,
    private readonly contextService: ContextService,
    private readonly route: ActivatedRoute,
    private readonly titleService: Title,
  ) {}

  ngOnInit(): void {
    this.init();
  }

  private async init() {
    await this.loadCollabUser();
    await this.setEditPermissions();
    this.titleService.setTitle(
      `Profil | ${this._collabUser?.nom} ${this._collabUser?.prenom}`,
    );
  }

  async loadCollabUser(): Promise<void> {
    const collabLogin = this.route.snapshot.paramMap.get('login');
    if (collabLogin) {
      this._collabUser =
        await this.utilisateurService.getUtilisateurByLogin(collabLogin);
    }
  }

  private async setEditPermissions(): Promise<void> {
    if (!this._collabUser) {
      return;
    }

    // Afin d'avoir une vision plus claire des permissions d'édition, veuillez vous référer à la documentation suivante :
    // https://adnov.atlassian.net/wiki/spaces/NPER/pages/482967803/Gestion+du+profil+mon-profil+ou+profil-collab
    const isCollabUserIdNot = this.utilisateurService.isUserIdNot(
      this._collabUser as Utilisateur,
    );
    const canEditBasicInfo = this.isCurrentUserNotaire && !isCollabUserIdNot;

    this._canEdit = {
      nom: canEditBasicInfo,
      prenom: canEditBasicInfo,
      email: false,
      phone: true,
    };
  }
}
